module.exports = __webpack_public_path__ + "img/IMG_6g.d6aba494.jpg";